/**
 * Sesotho: Knowledge base
 *
 * What this file covers: The knowledge base the chatbot answers from: documents, websites, corrections,
 * conflicts and trying a question.
 *
 * Tone: Plain and patient. Explain what the chatbot will and will not know.
 *
 * Sesotho: Everyday Sesotho as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const knowledge: Catalog = {
  'knowledge.add.hintMany': 'PDF, mongolo, Markdown, HTML kapa CSV, ho fihla ho 20 MB e nngwe le e nngwe. Kgetha tse ngata ka nako e le nngwe: faele ka nngwe e kenngwa moleng hang ha e se e kentswe, ebe e hlophiswa ka tatellano, mme ho hlophisa ho a tswela pele le ha o tloha leqepheng lena.',
  'knowledge.add.queued': 'E kentswe moleng hore e hlophiswe: {{count}}',
  'knowledge.add.refusedTitle': 'Difaele tse ding ha di a ekelwa',
  'knowledge.add.refused.PLAN_LIMIT_REACHED': '{{name}}: setsi sa tsebo sa moralo wa hao se tletse. Tlosa tokomane kapa o fetole moralo ho eketsa tse ding.',
  'knowledge.add.refused.ALREADY_ADDED': '{{name}}: e se e le teng setsing sa hao sa tsebo.',
  'knowledge.add.refused.NO_TEXT': '{{name}}: ha ho mongolo o balehang o fumanweng. PDF e skenilweng e hloka hore mongolo wa yona o hlokomelwe pele.',
  'knowledge.add.refused.MEDIA_NOT_FOUND': '{{name}}: ho kenya ha ho a fumanwa. E kenye hape.',
  'knowledge.add.refused.other': '{{name}}: {{message}}',
  'knowledge.add.sending': 'Ho ekelwa difaele tse kentsweng…',
  'knowledge.list.status': 'Boemo',
  'knowledge.status.queued': 'Moleng',
  'knowledge.status.indexing': 'E a hlophiswa',
  'knowledge.status.indexed': 'E hlophisitswe',
  'knowledge.status.failed': 'E hlolehile',
  'knowledge.list.retry': 'Leka {{name}} hape',
  'knowledge.list.pending': 'Ho hlophiswa ditokomane tse {{count}}, e nngwe ka nako. O ka tloha leqepheng lena.',
  'knowledge.toast.retried': '"{{name}}" e kentswe moleng hape',
  'knowledge.toast.retryFailed': 'Ha e a kgona ho kenya tokomane moleng hape',
  'knowledge.assistant.offerName': 'Fana ka motho oa sehlopha',
  'knowledge.assistant.offer': 'Na o ka rata hore ke fetisetse sena ho motho e mong oa sehlopha sa rona?',
  'knowledge.assistant.offerYes': 'E',
  'knowledge.assistant.offerNo': 'Che',
  'knowledge.assistant.offerRetry': 'Ka kopo araba E kapa Che.',
  'knowledge.assistant.declined': 'Ha ho bothata. Mpotse eng kapa eng e nngwe neng kapa neng.',
  'knowledge.assistant.intro': 'Batho ha ba latele phallo ha ba o romella molaetsa. Ba a botsa. Bulela sena \'me bot e tla araba molaetsa ofe kapa ofe o sa nkuoeng ke phallo e \'ngoe, ho tsoa litokomaneng tsohle tse mona. Ha e sa tiisehe, e qala ka ho botsa hore na ba ka rata thuso ea motho oa sehlopha sa hao, ebe e botsa hore na ba hloka eng le hore na ba ka fihlelloa joang, ebe e tsebisa sehlopha sa hao.'
};

export default knowledge;
